import SandboxForm from 'components/forms/SandboxForm/SandboxForm';
import { Modal } from 'semantic';
import React from 'react';
import modal from 'helpers/modal';

interface Props {
  onSave: () => void;
  title?: string;
  update?: boolean;
  onSubmit: (data: any) => Promise<void>;
  initialValues?: Partial<{
    name: string;
    description: string;
    sandboxProductModules: string[];
    sandboxData: string;
    sandboxDataSourceId: string;
  }>;
  // injected by modal HOC
  close: () => void;
}

const CreateSandboxModal: React.FC<Props> = ({
  onSave,
  title,
  update,
  onSubmit,
  initialValues,
  close,
}) => {
  return (
    <>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <SandboxForm
          update={update}
          initialValues={initialValues}
          onSubmit={(data) => onSubmit(data).then(close)}
          onSave={onSave}
          onCancel={() => close()}
        />
      </Modal.Content>
    </>
  );
};

export default modal(CreateSandboxModal);
